import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { SGF_API } from '../../../../../shared/api/sgf.api';

@Injectable({
  providedIn: 'root'
})
export class DespesasService {
  
  private despesa =  `${SGF_API}` +  'sgf/api/public/despesa';

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  findAll(): Observable<any> {
    return this.httpClient.get(this.despesa, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  create(customer): Observable<any> {
    const body = JSON.stringify(customer);
    return this.httpClient.post(this.despesa, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  update(customer): Observable<any> {
    const body = JSON.stringify(customer);
    return this.httpClient.put(this.despesa, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  httpOptions(token?: string): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': ''
      })
    };
  }

  httpOptionsFiles(token?: string): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'image/jpeg',
        'Authorization': ''
      })
    };
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a customer-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

}
